import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '../../theme/scalingTokens';

export const useSpaceSelectionStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '1rem',
    marginTop: '20px',
  },
  /** Figma 2026 Select Space root (node `1-1193`): consistent vertical rhythm. */
  rootFigma: {
    rowGap: tokens.spacingVerticalL,
    marginTop: tokens.spacingVerticalM,
  },
  /**
   * Figma criteria summary bar (node `1-1223`): white card with neutral
   * border, edit link on the right.
   */
  criteriaBarFigma: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderRadius('0.5rem'),
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalL),
    [mq.mobile]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      rowGap: tokens.spacingVerticalS,
    },
  },
  listHeaderFigma: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: tokens.spacingHorizontalM,
  },
  resultCountFigma: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  /**
   * Figma sticky footer (node `1-1380`): full-width bar at the bottom of the
   * Select Space step with back / status / continue arrangement.
   */
  stickyFooterFigma: {
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground1,
    borderTopColor: tokens.colorNeutralStroke1,
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalL),
    marginTop: tokens.spacingVerticalL,
  },
  stickyFooterStatusFigma: {
    flex: '1 1 auto',
    textAlign: 'center',
    color: tokens.colorNeutralForeground3,
    fontSize: fontScale.caption,
  },
  grid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '200px',
    ...shorthands.padding('3rem'),
    [mq.mobile]: {
      ...shorthands.padding('2rem', '1rem'),
      minHeight: '200px',
    },
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    ...shorthands.padding('3rem'),
    rowGap: '0.75rem',
    color: tokens.colorNeutralForeground2,
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('1rem'),
    boxShadow: tokens.shadow4,
    [mq.mobile]: {
      ...shorthands.padding('1.5rem', '1rem'),
      ...shorthands.borderRadius('0.75rem'),
    },
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ...shorthands.padding('3rem'),
    rowGap: '0.75rem',
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('1rem'),
    boxShadow: tokens.shadow4,
    [mq.mobile]: {
      ...shorthands.padding('1.5rem', '1rem'),
      ...shorthands.borderRadius('0.75rem'),
    },
  },
  errorText: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: fontScale.body,
  },
  subtitleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalM,
  },
  subtitle: {
    fontSize: fontScale.title,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  resultCount: {
    fontSize: fontScale.subtitle,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    margin: 0,
  },
});
